export class PhonePrefix {
  phonePrefixId: string;
  country: string;
  value: string;
  code: string;
  deleted: number;

  constructor(params: PhonePrefixParams) {
    this.phonePrefixId = params.phonePrefixId;
    this.country = params.country;
    this.value = params.value;
    this.code = params.code;
    this.deleted = params.deleted;
  }
}

interface PhonePrefixParams {
  phonePrefixId: string;
  country: string;
  value: string;
  code: string;
  deleted: number;
}
